
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vefverslun/[category]",
      function () {
        return require("private-next-pages/vefverslun/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vefverslun/[category]"])
      });
    }
  